<script lang="ts">
	import { Locale } from "@core/schema/Locale.js";
	import { localAliasNameMap } from "@core/schema/names/localAliasNameMap.js";
	import { localeNameMap } from "@core/schema/names/localeNameMap.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { tenant, pagePath } = getGlobalTemplateProps();
</script>

<div class="flex gap-4 size-fit">
	{#each Object.values(Locale) as targetLocale (targetLocale)}
		{@const isCurrentLocale = targetLocale === tenant.locale}
		{@const href = pagePath[targetLocale]}
		<svelte:element
			this={isCurrentLocale ? "span" : "a"}
			href={isCurrentLocale ? undefined : href}
			referrerpolicy="no-referrer"
			rel="noreferrer"
			class={[
				"size-16 transition-colors",
				href ? "text-white" : "text-fcrgray",
				isCurrentLocale ? "border-white" : ["border-white/16", href ? "hover:border-white" : "cursor-not-allowed"],
				"flex justify-center items-center rounded-full border",
			]}
			title={localeNameMap[tenant.locale][targetLocale]}
		>
			<span class="text-sm/4 font-medium pointer-events-none">{localAliasNameMap[targetLocale]}</span>
		</svelte:element>
	{/each}
</div>
